import api from './api';

/**
 * Secure document viewer API.
 *
 * The platform keeps the access token in memory inside the shared `api`
 * client. Therefore, this service must use that same client instead of
 * creating a separate Axios instance or reading tokens from localStorage.
 */
export const documentViewerAPI = {
  /**
   * Request a governed secure-viewing session for a document.
   */
  requestViewSession: async (documentId, payload = {}) => {
    const response = await api.post(
      `/v1/documents/${encodeURIComponent(
        documentId,
      )}/request-view/`,
      payload,
    );

    return response.data;
  },

  /**
   * Get the current secure-viewing session status.
   */
  getSessionStatus: async (sessionToken) => {
    const response = await api.get(
      `/v1/documents/view/${encodeURIComponent(
        sessionToken,
      )}/status/`,
    );

    return response.data;
  },

  /**
   * Get one encrypted chunk for a document page.
   */
  getPageChunk: async (
    sessionToken,
    pageNumber,
    chunkIndex,
  ) => {
    const response = await api.get(
      `/v1/documents/view/${encodeURIComponent(
        sessionToken,
      )}/page/${encodeURIComponent(
        String(pageNumber),
      )}/chunk/${encodeURIComponent(
        String(chunkIndex),
      )}/`,
    );

    return response.data;
  },

  /**
   * Send a heartbeat to keep the secure-viewing session alive.
   */
  sendHeartbeat: async (sessionToken) => {
    const response = await api.post(
      `/v1/documents/view/${encodeURIComponent(
        sessionToken,
      )}/heartbeat/`,
      {},
    );

    return response.data;
  },

  /**
   * Close the secure-viewing session.
   */
  closeSession: async (sessionToken) => {
    const response = await api.post(
      `/v1/documents/view/${encodeURIComponent(
        sessionToken,
      )}/close/`,
      {},
    );

    return response.data;
  },
};

export default documentViewerAPI;